"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedheart01sm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedheart01sm` : '') + (description ? ` desc-brandedheart01sm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedheart01sm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedheart01sm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.71 1.43 9 2.15l-.72-.72A4.84 4.84 0 0 0 .51 2.7l-.1.19a4.9 4.9 0 0 0 .86 5.27l7.27 7.64c.25.27.67.27.92 0l7.13-7.5a4.88 4.88 0 0 0 .9-5.6l-.1-.2A4.86 4.86 0 0 0 9.7 1.43Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9 2.15.71-.72A4.84 4.84 0 0 1 17.4 2.5l.1.2a4.88 4.88 0 0 1-.9 5.6l-7.13 7.5c-.13.13-.3.2-.46.2V2.15Z",
    fill: "#CC0058"
  }));
};
var _default = exports.default = brandedheart01sm;